/** @format */

import { Component, computed, inject, input } from '@angular/core';

import { Chain, ProcessedProduct, ProductStyle } from '@shared/data-access/interfaces';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { selectKillswitch } from '@pdp/data-access/state';

@Component({
	selector: 'pdp-product-info-specs',
	imports: [CommonModule],
	templateUrl: './product-info-specs.component.html',
	styleUrls: ['./product-info-specs.component.scss']
})
export class ProductInfoSpecsComponent {
	protected readonly chain = inject(Chain);
	private readonly store = inject(Store);

	backgroundImage = input<string>();
	sectionTitle = input<string>('About This Item');
	product = input.required<ProcessedProduct | ProductStyle>();
	descriptiveH2Enabled = this.store.selectSignal(selectKillswitch('isDescriptiveH2Enabled'));
	descriptiveH2Text = computed(() => {
		const productData = this.product();
		if (!this.descriptiveH2Enabled() || !('descriptiveAttributes' in productData)) {
			return;
		}
		const subtitleAttribute = productData.descriptiveAttributes.find(
			(attr) => attr.name == 'Subtitle'
		);
		return subtitleAttribute?.value.toString();
	});
}
